import React, { useState } from 'react'
import { StyledLogin } from './Login.style'

import Logo from "../../assets/images/main_logo.png"

export default function Login() {
    const [user, setUser] = useState({
        "username": "",
        "password": ""
    })

    const changeUser = (e) => {
        const { name, value } = e.target
        setUser((p) => ({
            ...p,
            [name]: value
        }))
    }

    const login = (e) => {
        e.preventDefault();
        setUser({
            "username": "",
            "password": ""
        })
    }
    return (
        <StyledLogin>
            <div className='login'>
                <div className='login-logo'>
                    <img src={Logo} alt="logo" />
                </div>
                <p>Log in to your account</p>
                <form className='login-form' autoComplete='off' onSubmit={login}>
                    <label htmlFor=''>Username</label>
                    <input
                        placeholder='Username'
                        name='username'
                        onChange={changeUser}
                        value={user.username}
                        required={true}
                    />
                    <label htmlFor=''>Password</label>
                    <input
                        placeholder='Password'
                        name='password'
                        type={"password"}
                        onChange={changeUser}
                        value={user.password}
                        required={true}
                    />
                    <button type='submit'>Log In</button>
                </form>
                <a href='/'>Forgot Password</a>
            </div>
        </StyledLogin>
    )
}
